import React, { useEffect } from "react";

const GOLD = "#d4a550";
const GOLD_DIM = "rgba(212,165,80,0.15)";
const GOLD_BORDER = "rgba(212,165,80,0.35)";
const BG_SURFACE = "#12121a";
const BORDER = "rgba(255,255,255,0.07)";
const TEXT = "#e8e6df";
const TEXT_DIM = "rgba(232,230,223,0.45)";

export default function StepParallelismi({ data, onChange }) {
  const { episodes = [], phases = [], parallelismi = {} } = data;

  // Inizializza parallelismi con default 1 se mancanti
  useEffect(() => {
    const init = { ...parallelismi };
    let changed = false;
    episodes.forEach(ep => {
      phases.forEach(ph => {
        const key = `${ep.episodeNo}_${ph.typeKey || ph.name}`;
        if (init[key] === undefined) { init[key] = 1; changed = true; }
      });
    });
    if (changed) onChange({ parallelismi: init });
  }, [episodes, phases]);

  function getKey(ep, ph) {
    return `${ep.episodeNo}_${ph.typeKey || ph.name}`;
  }

  function getMaxLines(ph) {
    return Math.max(1, Number(ph.defaultLines) || 1);
  }

  function setValue(ep, ph, val) {
    const v = Math.max(1, Math.min(getMaxLines(ph), parseInt(val) || 1));
    onChange({ parallelismi: { ...parallelismi, [getKey(ep, ph)]: v } });
  }

  function applyToAll(ph, val) {
    const v = Math.max(1, Math.min(getMaxLines(ph), parseInt(val) || 1));
    const next = { ...parallelismi };
    episodes.forEach(ep => { next[getKey(ep, ph)] = v; });
    onChange({ parallelismi: next });
  }

  if (!episodes.length || !phases.length) {
    return <div style={{ color: TEXT_DIM, fontSize: 13 }}>Completa prima gli step Episodi e Fasi.</div>;
  }

  const cellStyle = {
    background: "rgba(255,255,255,0.03)",
    border: `1px solid ${BORDER}`,
    borderRadius: 4,
    color: TEXT,
    fontSize: 13,
    padding: "4px 6px",
    width: 52,
    textAlign: "center",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ fontSize: 12, color: TEXT_DIM, lineHeight: 1.6 }}>
        Definisci quante linee parallele vuoi per ogni fase su ogni episodio. 
        Usa <span style={{ color: GOLD }}>Applica a tutti</span> per impostare lo stesso valore su tutti gli episodi.
      </div>

      <div style={{ overflowX: "auto", overflowY: "auto", maxHeight: 420, scrollbarWidth: "thin", scrollbarColor: "rgba(212,165,80,0.4) transparent" }}>
        <table style={{ borderCollapse: "collapse", fontSize: 12, minWidth: "100%" }}>
          <thead>
            <tr style={{ background: BG_SURFACE }}>
              <th style={{ padding: "8px 12px", textAlign: "left", color: TEXT_DIM, fontWeight: 600, borderBottom: `1px solid ${BORDER}`, minWidth: 60, position: "sticky", left: 0, background: "#0f0f17", zIndex: 3 }}>Ep.</th>
              {phases.map(ph => (
                <th key={ph.typeKey || ph.name} style={{ padding: "8px 12px", textAlign: "center", color: TEXT_DIM, fontWeight: 600, borderBottom: `1px solid ${BORDER}`, minWidth: 100 }}>
                  {ph.name}
                </th>
              ))}
            </tr>
            {/* Riga applica a tutti */}
            <tr style={{ background: "rgba(212,165,80,0.04)" }}>
              <td style={{ padding: "6px 12px", color: GOLD, fontSize: 11, fontWeight: 700 }}>↓ Applica<br/>a tutti</td>
              {phases.map(ph => (
                <td key={ph.typeKey || ph.name} style={{ padding: "6px 12px", textAlign: "center" }}>
                  <input
                    type="number" min={1} max={getMaxLines(ph)}
                    defaultValue={1}
                    onChange={e => applyToAll(ph, e.target.value)}
                    style={{ ...cellStyle, border: `1px solid ${GOLD_BORDER}`, background: GOLD_DIM }}
                  />
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {episodes.map((ep, i) => (
              <tr key={ep.episodeNo} style={{ borderBottom: `1px solid ${BORDER}`, background: i % 2 === 0 ? "transparent" : "rgba(255,255,255,0.01)" }}>
                <td style={{ padding: "6px 12px", color: TEXT_DIM, fontWeight: 600, position: "sticky", left: 0, background: "#0f0f17", zIndex: 2, borderRight: `1px solid ${BORDER}` }}>Ep. {ep.episodeNo}</td>
                {phases.map(ph => (
                  <td key={ph.typeKey || ph.name} style={{ padding: "6px 12px", textAlign: "center" }}>
                    <input
                      type="number" min={1} max={getMaxLines(ph)}
                      value={parallelismi[getKey(ep, ph)] ?? 1}
                      onChange={e => setValue(ep, ph, e.target.value)}
                      style={cellStyle}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
